import api from './api';

class ReferralService {
  /**
   * Obtenir les statistiques de parrainage de l'utilisateur connecté
   */
  async getMyReferralStats() {
    const response = await api.get('/api/referrals/my-stats');
    return response.data;
  }

  /**
   * Obtenir le code de parrainage de l'utilisateur connecté
   */
  async getMyReferralCode() {
    const response = await api.get('/api/referrals/my-code');
    return response.data;
  }

  /**
   * Valider un code de parrainage
   */
  async validateCode(code) {
    const response = await api.post('/api/referrals/validate-code', { code });
    return response.data;
  }

  /**
   * (Admin) Obtenir les statistiques de parrainage d'un utilisateur
   */
  async getUserReferralStats(userId) {
    const response = await api.get(`/api/admin/referrals/users/${userId}/stats`);
    return response.data;
  }
}

export default new ReferralService();

